import { render, staticRenderFns } from "./GlossaryHomepage.vue?vue&type=template&id=ee2f30a8&scoped=true&"
import script from "./GlossaryHomepage.vue?vue&type=script&lang=ts&"
export * from "./GlossaryHomepage.vue?vue&type=script&lang=ts&"
import style0 from "./GlossaryHomepage.vue?vue&type=style&index=0&id=ee2f30a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2f30a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlossaryChapter: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/glossary/GlossaryChapter.vue').default})
